<template>
  <v-menu
    v-model="showPicker"
    :close-on-content-click="false"
    max-width="50%"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="pickerDate"
        readonly
        v-on="on"
        :disabled="isAllTextFieldDisabled"
        @keyup.enter="keyupEnter"
        clearable
      >
        <template v-slot:label>
          {{ $t(dateName) }}
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="pickerDate"
      :min="minDate"
      :locale="getLocale"
      @input="showPicker = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePickerSetTimeNotRequest',
  props: {
    dateName: {
      type: String
    },
    isAllTextFieldDisabled: {
      type: Boolean,
      default: false
    },
    time: {
      type: Number
    },
    minDate: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showPicker: false,
      pickerDate: null
    }
  },
  mounted () {
    this.setTime()
  },
  computed: {
    getLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    keyupEnter (event) {
      this.showPicker = false
      this.$emit('keyupEnter', event)
    },
    setTime () {
      if (this.time !== 0) {
        this.pickerDate = this.$moment(this.time).format('YYYY-MM-DD')
      }
    }
  },
  components: {},
  watch: {
    pickerDate (newVal) {
      let timestamp = ''
      if (newVal !== '' && newVal !== null) {
        timestamp = Date.parse(newVal + ' 00:00:00:000')
      } else {
        timestamp = 0
      }
      this.$emit('setDate', timestamp)
    },
    time () {
      this.setTime()
    }
  }
}
</script>

<style></style>
